// React Lib
import React, { useState } from "react";
// Component Styles
import { useStyles } from "./UserAccountStyles";
// @otg-one/ui_components/components
import { Chip, Typography } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// Assets
import ShowMoreHorizontal from "../../icons/ShowMore/Horizontal";
import { OverflowMenu } from "../OverflowMenu";
import { Delete } from "../../sap_icons";
export const UserAccount = (props) => {
    const classes = useStyles(props);
    const { id, user, setActiveUser, setDeleteUserDialogOpen, onClick, menuItem } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClickShowMoreIcon = (event) => {
        event.stopPropagation();
        if (!anchorEl) {
            console.log("OPEN", anchorEl);
            setAnchorEl(event.currentTarget);
        }
        ;
    };
    return (React.createElement("div", { className: classes.userAccountBox, onClick: onClick, id: id },
        React.createElement(ShowMoreHorizontal, { onClick: handleClickShowMoreIcon }),
        React.createElement(OverflowMenu, { anchorElement: anchorEl, setAnchorEl: setAnchorEl, menuItems: [
                {
                    text: [menuItem[0].text],
                    icon: React.createElement(Delete, { style: { color: Color.danger[500] } }),
                    destructive: true,
                    onClick: () => {
                        setActiveUser(user);
                        setDeleteUserDialogOpen(true);
                    }
                }
            ] }),
        React.createElement("div", { id: `${id}-user-account-picture`, className: classes.userAccountPicture }),
        React.createElement("div", null,
            React.createElement(Typography, { id: `${id}-user-account-name`, fontFamily: FONT_FAMILY.CAPITOLIUM_BOLD, size: 24, style: {
                    marginTop: 20
                } }, user.name),
            React.createElement(Typography, { id: `${id}-user-account-email`, fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, style: {
                    marginTop: 5
                } }, user.email),
            user.status === "ADMIN" && (React.createElement(Chip, { id: `${id}-user-account-status`, backgroundColor: Color.gradient[100], style: {
                    marginTop: 30
                } }, user.status)))));
};
UserAccount.defaultProps = {
    user: {
        img: "",
        name: "Jesse Young",
        email: "jesse.young@commsult.id",
        status: "USER"
    },
    onClick: () => { },
    setActiveUser: null,
    setDeleteUserDialogOpen: () => { },
    menuItem: [
        { text: "Delete" }
    ]
};
export default React.memo(UserAccount);
